<template>
    <transition name="modal-fade">
        <div class="modal-backdrop">
            <div
                class="modal"
                role="dialog"
                aria-labelledby="modalTitle"
                aria-describedby="modalDescription"
            >
                <header class="modal-header" id="modalTitle">
                    <slot name="header">
                        Questions
                        <h2></h2>
                    </slot>
                </header>
                <section class="modal-body" id="modalDescription">
                    <slot name="body">
                        <div class="questions">
                            <p class="quiz-title"></p>
                            <form id="radio_group">
                                <div class="grade-row">
                                    <div class="form-check col-3" @click="changeSelectedOption(0)">
                                        <input
                                            type="radio"
                                            class="form-check-input"
                                            id="materialGroupExample1"
                                            name="groupOfMaterialRadios"
                                        />
                                        <label
                                            class="form-check-label"
                                            for="materialGroupExample1"
                                        ></label>
                                    </div>
                                    <div class="form-check col-3" @click="changeSelectedOption(1)">
                                        <input
                                            type="radio"
                                            class="form-check-input"
                                            id="materialGroupExample1"
                                            name="groupOfMaterialRadios"
                                        />
                                        <label
                                            class="form-check-label"
                                            for="materialGroupExample1"
                                        ></label>
                                    </div>
                                    <div class="form-check col-3" @click="changeSelectedOption(2)">
                                        <input
                                            type="radio"
                                            class="form-check-input"
                                            id="materialGroupExample1"
                                            name="groupOfMaterialRadios"
                                        />
                                        <label
                                            class="form-check-label"
                                            for="materialGroupExample1"
                                        ></label>
                                    </div>
                                    <div class="form-check col-3" @click="changeSelectedOption(3)">
                                        <input
                                            type="radio"
                                            class="form-check-input"
                                            id="materialGroupExample1"
                                            name="groupOfMaterialRadios"
                                        />
                                        <label
                                            class="form-check-label"
                                            for="materialGroupExample1"
                                        ></label>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div id="thank-you-msg">
                            <span
                                >Thank You in taking Part<br />
                                You will get your results soon...</span
                            >
                        </div>
                    </slot>
                </section>
                <footer class="modal-footer">
                    <slot name="footer">
                        <button
                            id="next"
                            type="button"
                            class="btn-green"
                            @click="onNext"
                            aria-label="Close modal"
                            style="margin-right:50px;width:100px;height:30px;font-size:15px;"
                        >
                            Next
                        </button>
                    </slot>
                </footer>
            </div>
        </div>
    </transition>
</template>
<script>
// import $ from 'jquery'
// import { VueMathjax } from 'vue-mathjax'
import { HTTP } from "../_helper/http-constants"

export default {
    name: "QuizModal",
    components: {
        // 'vue-mathjax': VueMathjax
    },
    data() {
        return {
            result: [],
            closemodal: false,
            selectedOption: 0,
            questions: [
                "The additive inverse of \\begin{align*}-{7\\over4}\\end{align*}",
                "Rational number \\begin{align*}3\\over40\\end{align*} is equal to:",
                "Which of the following is not the reciprocal of \\begin{align*} \\left( 2\\over3\\right)^4\\end{align*}?",
                "The polygon having 5 diagonals is _____",
                "A quadrilateral has one angle equal to \\begin{align*}120^o\\end{align*} and its other three angles are equal. The measure of the equal angles is",
            ],
            answers: [
                [
                    "1",
                    "0",
                    "\\begin{align*}-{7\\over4}\\end{align*}",
                    "\\begin{align*}7\\over4\\end{align*}",
                ],
                ["0.75", "0.12", "0.012", "0.075"],
                [
                    "\\begin{align*} \\left( 2\\over3\\right)^4\\end{align*}",
                    "\\begin{align*} \\left( 3\\over2\\right)^4\\end{align*}",
                    "\\begin{align*} \\left( 3\\over2\\right)^{-4}\\end{align*}",
                    "\\begin{align*}3^4 \\over 2_4\\end{align*}",
                ],
                ["A quadrilateral", "A pentagon", "An octagon", "A hexagon"],
                [
                    "\\begin{align*}40^o\\end{align*}",
                    "\\begin{align*}60^o\\end{align*}",
                    "\\begin{align*}80^o\\end{align*}",
                    "\\begin{align*}100^o\\end{align*}",
                ],
            ],
            msg: "Welcome to Your Vue.js App",
            currentQuizNum: 0,
        }
    },
    methods: {
        onNext() {
            var _vm = this
            if (this.currentQuizNum >= 4) {
                $(".questions").css("display", "none")
                $("#thank-you-msg").css("display", "block")
                if (this.closemodal) {
                    this.$emit("close")
                }
                if (this.currentQuizNum == 4) {
                    $("#next").text("Close")
                    this.result.push({
                        question: _vm.questions[_vm.currentQuizNum],
                        answer: _vm.answers[_vm.currentQuizNum][_vm.selectedOption],
                    })
                    var user = JSON.parse(window.localStorage.getItem("user"))
                    const headers = {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + user.token,
                    }
                    HTTP.post(
                        "/users/aptitude-result",
                        {
                            user_id: user.id,
                            result: _vm.result,
                        },
                        {
                            headers: headers,
                        }
                    )
                        .then((res) => {
                            this.closemodal = true
                            console.log(res)
                        })
                        .catch((e) => {
                            console.log("err message", e.message)
                        })
                }
            } else {
                this.result.push({
                    question: _vm.questions[_vm.currentQuizNum],
                    answer: _vm.answers[_vm.currentQuizNum][_vm.selectedOption],
                })
                this.currentQuizNum++
            }
            this.$forceUpdate()
        },
        changeSelectedOption(option) {
            this.selectedOption = option
        },
    },
}
</script>

<style scoped>
.modal-backdrop {
    position: fixed;
    top: 20vw;
    bottom: 0;
    left: 20vw;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60vw;
    height: 60vh;
    background-color: unset !important;
}

.modal-back {
    position: fixed;
    z-index: 99999;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.8);
}

.modal {
    background: #ffffff;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    width: 60%;
    height: 80%;
    top: 20%;
    left: 20%;
    box-shadow: unset !important;
}

.modal-header,
.modal-footer {
    padding: 15px;
    display: flex;
}

.modal-header {
    border-bottom: 1px solid #eeeeee;
    color: #4aae9b;
    justify-content: space-between;
}

.modal-footer {
    border-top: 1px solid #eeeeee;
    justify-content: flex-end;
}

.modal-body {
    position: relative;
    padding: 20px 10px;
}

.btn-close {
    border: none;
    font-size: 20px;
    padding: 20px;
    cursor: pointer;
    font-weight: bold;
    color: #4aae9b;
    background: transparent;
}

.btn-green {
    color: white;
    background: #4aae9b;
    border: 1px solid #4aae9b;
    border-radius: 2px;
}

.btn-green:disabled {
    background: grey;
}
</style>
